import { P } from '@farewill/ui'

const ErrorResults = ({ type }) => (
  <P>
    Error loading {type}! <span aria-hidden>😞</span> Try refreshing?
  </P>
)

export default ErrorResults
